"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORMAT_TYPE = void 0;
var FORMAT_TYPE = exports.FORMAT_TYPE = 'EPUB';